import randomInt from '../../utils/randomInt';
import BoardCard from './BoardCard';

class Board {
  static totalFields = 25;
  static amountWordsStart = 9;
  #cells = [];
  #missingWordsTeamA = Board.amountWordsStart;
  #missingWordsTeamB = Board.amountWordsStart;

  constructor(startTeam, wordList) {
    if (startTeam === 'A') {
      this.#missingWordsTeamB--;
    } else {
      this.#missingWordsTeamA--;
    }

    const types = ['black'];
    for (let i = 0; i < this.#missingWordsTeamA; i++) {
      types.push('A');
    }
    for (let i = 0; i < this.#missingWordsTeamB; i++) {
      types.push('B');
    }
    for (let i = 0; i < Board.totalFields - Board.amountWordsStart * 2; i++) {
      types.push('neutral');
    }

    const wordListCopy = [...wordList];
    for (let cell = 0; cell < Board.totalFields; cell++) {
      const wordIndex = randomInt(0, wordListCopy.length - 1);
      const word = wordListCopy.splice(wordIndex, 1)[0];

      const typeIndex = randomInt(0, types.length - 1);
      const type = types.splice(typeIndex, 1)[0];

      this.#cells.push(new BoardCard(word, type));
    }
  }

  get cells() {
    return this.#cells;
  }

  get missingWordsTeamA() {
    return this.#missingWordsTeamA;
  }

  get missingWordsTeamB() {
    return this.#missingWordsTeamA;
  }

  reveal(cellIndex) {
    const type = this.#cells[cellIndex].reveal();

    switch (type) {
      case 'A':
        this.#missingWordsTeamA--;
        break;

      case 'B':
        this.#missingWordsTeamB--;
        break;
    }

    return type;
  }

  toJson() {
    return this.cells.map((cell, index) => {
      return { ...cell.toJson(), index };
    });
  }
}

export default Board;
